import { render } from "./updateMesure.vue?vue&type=template&id=5a2855cf&scoped=true"
import script from "./updateMesure.vue?vue&type=script&lang=js"
export * from "./updateMesure.vue?vue&type=script&lang=js"

import "./updateMesure.vue?vue&type=style&index=0&id=5a2855cf&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2855cf"]])

export default __exports__